import { Icon } from "@chakra-ui/react";
import { AiFillMedicineBox } from "react-icons/ai";

export const LogoIcon = () => {
  return <Icon as={AiFillMedicineBox} w="2em" height="2em" />;
};
